import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from './state/app-state';
import { TenantStateProvider } from './state/tenant-state';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SearchStateProvider } from './state/search-sate';

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppStateProvider>
        <QueryClientProvider client={queryClient}>
          <TenantStateProvider>
            <SearchStateProvider>
              <App />
            </SearchStateProvider>
          </TenantStateProvider>
        </QueryClientProvider>
      </AppStateProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// disable default validation popups
document.addEventListener(
  'invalid',
  (
    () =>
    (event): void => {
      event.preventDefault();
    }
  )(),
  true,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
